import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';

import { OrganisationMappingModel } from '@auth/models/user/organisation-mapping.model';
import { UserService } from '@auth/services/user.service';
import { CurrentOrganizationService } from '@auth/services/current-organization.service';
import { FetchOrganizationSelection } from '@auth/state/actions/organization/fetch-organization-selection.action';
import { FetchOrganizationSelectionSuccess } from '@auth/state/actions/organization/fetch-organization-selection-success.action';

export interface UserOrganizationStateModel {
  organizations: OrganisationMappingModel[];
  currentOrganization: OrganisationMappingModel;
}

@State<UserOrganizationStateModel>({
  name: 'organizationSelection',
  defaults: {
    organizations: [],
    currentOrganization: {}
  } as unknown as UserOrganizationStateModel
})
@Injectable()
export class OrganizationSelectionState {
  constructor(private userService: UserService,
    private currentOrganizationService: CurrentOrganizationService) {
  }

  @Action(FetchOrganizationSelection)
  public fetchUserOrganization(ctx: StateContext<UserOrganizationStateModel>): void {
    const currentOrganization = this.currentOrganizationService.getCurrentOrganization();
    const organizations = this.userService.currentUser.userOrganisationMappings ?? [];
    ctx.dispatch(new FetchOrganizationSelectionSuccess({ organizations, currentOrganization }));
  }

  @Action(FetchOrganizationSelectionSuccess)
  public fetchUserOrganizationSuccess(ctx: StateContext<UserOrganizationStateModel>,
    action: FetchOrganizationSelectionSuccess): void {
    const state = ctx.getState();
    const organizations = action.payload.organizations;
    const currentOrganization = action.payload.currentOrganization;
    ctx.setState({ ...state, currentOrganization, organizations });
  }
}
